import { render, staticRenderFns } from "./PP.vue?vue&type=template&id=4d063f82&scoped=true"
import script from "./PP.vue?vue&type=script&lang=js"
export * from "./PP.vue?vue&type=script&lang=js"
import style0 from "./PP.vue?vue&type=style&index=0&id=4d063f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d063f82",
  null
  
)

export default component.exports